import { marginTopBottom, header, sectionHeader } from "./DocDefition";
import {  charts } from "./ImageDefinition";


export const CompanyDashboardPDF = async (
  vision: string,
  mission: string,
  chartsImageDataUrl: string
) => {
  const _charts = await charts(chartsImageDataUrl); // should embed image

  return {
    pageSize: "A1",
    pageOrientation: "portrait",
    content: [
      marginTopBottom(),
      header("Dashboard Performance Report"),
      marginTopBottom(),
      sectionHeader(mission),
      marginTopBottom(),
      sectionHeader(vision),
      marginTopBottom(),
      _charts,
      marginTopBottom(),
      marginTopBottom(),
      marginTopBottom(),
    ],
  };
};

